module.exports = __webpack_public_path__ + "static/media/pdi-image-04.fd24386b.svg";